import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { StandortsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [StandortsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class StandortsServiceModule {}
